<template>
	<div v-if="info">
		<card header-classes="bg-dark">
			<template slot="header">
				<h3 class="mb-0 text-white">ข้อมูลสมาชิก #{{ id }}</h3>
			</template>
			<div class="row" v-if="info">
				<div class="col-md-6">
					<dl class="row pb-2">
						<dt class="col-md-4">เบอร์โทรศัพท์</dt>
						<dd class="col-md-8">{{ info.phone }}</dd>
						<dt class="col-md-4">ชื่อสมาชิก</dt>
						<dd class="col-md-8">
							{{ info.firstName }} {{ info.lastName }}
						</dd>
						<dt class="col-md-4">ไอดีไลน์</dt>
						<dd class="col-md-8">{{ info.lineID }}</dd>
						<dt class="col-md-4">รู้จักเราจาก</dt>
						<dd class="col-md-8">
							<span v-if="info.knowFrom == 'friend'">
								เพื่อนแนะนำ
								<router-link
									:to="
										`/dashboard/members/${info.affiliate.id}`
									"
									v-if="info.affiliate.id"
								>
									#{{ info.affiliate.id }}
								</router-link>
							</span>
							<span v-else>{{ info.knowFrom }}</span>
						</dd>
						<dt class="col-md-4">วันที่สมัครสมาชิก</dt>
						<dd class="col-md-8">
							{{ info.createdAt | moment('DD/MM/YYYY HH:mm') }}
						</dd>
					</dl>
				</div>
				<div class="col-md-6">
					<dl class="row pb-2 border-bottom">
						<dt class="col-md-4">ธนาคาร</dt>
						<dd class="col-md-8">{{ info.bankCode | bankName }}</dd>
						<dt class="col-md-4">เลขบัญชี</dt>
						<dd class="col-md-8">{{ info.bankNumber }}</dd>
					</dl>
					<dl class="row pb-2">
						<dt class="col-md-4">ยอดเชิญเพื่อนคงเหลือ</dt>
						<dd class="col-md-8">{{ info.affiliate.balance }}</dd>
						<dt class="col-md-4">ยอดคงเหลือขั้นต่ำ</dt>
						<dd class="col-md-8">
							{{ info.minAvailable | format(0) }} บาท
						</dd>
						<dt class="col-md-4">ยอดถอนขั้นต่ำ</dt>
						<dd class="col-md-8">
							{{ info.minWithdraw | format(0) }} บาท
						</dd>
						<dt class="col-md-4">ยอดถอนสูงสุด</dt>
						<dd class="col-md-8">
							{{ info.maxWithdraw | format(0) }} บาท
						</dd>
					</dl>
				</div>

				<div class="col-md-12 pt-3 border-top">
					<base-button
						type="primary"
						@click="viewMemberInfo()"
						:disabled="loading"
					>
						ดูข้อมูลยูสเซอร์
					</base-button>
					<base-button
						type="warning"
						@click="reGameUser()"
						:disabled="loading"
					>
						เปิดยูสเซอร์ใหม่
					</base-button>
				</div>
			</div>
			<div class="d-flex justify-content-center" v-else>
				<i class="fas fa-spinner fa-spin fa-3x py-5" />
			</div>
		</card>

		<div class="row">
			<div class="col-md-6">
				<bonus-table :data="bonusTransactions" />
			</div>
			<div class="col-md-6">
				<affiliate-table :data="affiliates" />
			</div>
		</div>
	</div>
</template>

<script>
import TxTable from '../backend-components/Member/TxTable'
import BonusTable from '../backend-components/Member/BonusTable'
import AffiliateTable from '../backend-components/Member/AffiliateTable'

import Swal from 'sweetalert2'
import MemberService from '../services/member.service'
import api from '../services'

export default {
	components: {
		TxTable,
		BonusTable,
		AffiliateTable,
	},
	data() {
		return {
			id: this.$route.params.id,
			loading: false,

			info: null,
			transactions: [],
			bonusTransactions: [],
			affiliates: [],
		}
	},
	computed: {
		deposit() {
			return this.depositTransactions
				.filter(
					(x) => x.status !== 'reject' && x.transferFrom !== 'ADMIN'
				)
				.reduce((c, tx) => tx.amount + c, 0)
		},
		withdraw() {
			return this.withdrawTransactions
				.filter(
					(x) => x.status !== 'reject' && x.transferFrom !== 'ADMIN'
				)
				.reduce((c, tx) => tx.amount + c, 0)
		},
		depositTransactions() {
			return this.transactions.filter(
				(tx) => tx.type === 'deposit' && tx.transferFrom !== 'BONUS'
			)
		},
		withdrawTransactions() {
			return this.transactions.filter((tx) => tx.type === 'withdraw')
		},
		affiliateTransactions() {
			return this.transactions.filter((tx) => tx.type === 'affiliate')
		},
	},
	methods: {
		getMemberInfo() {
			MemberService.getMemberInfo(this.id)
				.then(
					({
						member,
						transactions,
						bonusTransactions,
						affiliates,
					}) => {
						this.info = member
						// this.transactions = transactions
						this.bonusTransactions = bonusTransactions
						this.affiliates = affiliates
					}
				)
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
		},
		viewMemberInfo() {
			this.loading = true
			MemberService.getMemberInfo(this.id, true)
				.then(({ member, credit, currentTurnover }) => {
					Swal.fire({
						icon: 'info',
						title: 'ข้อมูลยูสเซอร์',
						html: `
							<h3 class="mt-3"><b>${member.game.username}</b></h3>
							<h3><b>${member.game.password}</b></h3>
							<h3>เครดิตคงเหลือ: <b>${this.$options.filters.format(credit)}</b></h3>
							<h3>เทิร์นโอเวอร์: <b>${this.$options.filters.format(currentTurnover)}</b></h3>
						`,
					})
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
		async reGameUser() {
			const modal = await Swal.fire({
				title: 'ต้องการเปิดยูสเซอร์ใหม่?',
				text: 'เมื่อเปิดเปิดยูสเซอร์ใหม่เครดิตเก่าจะหายทั้งหมด',
				showCancelButton: true,
			})
			if (!modal.value) {
				return false
			}

			try {
				this.loading = true
				await api.post(`/members/${this.id}/game-user`)

				this.$notify({
					type: 'success',
					message: 'ดำเนินการสำเร็จ',
				})
			} catch ({ message }) {
				this.$notify({
					type: 'danger',
					message: message,
				})
			} finally {
				this.loading = false
			}
		},
	},
	created() {
		this.getMemberInfo()
	},
	watch: {
		$route() {
			this.id = this.$route.params.id
			this.info = null
			this.getMemberInfo()
		},
	},
}
</script>
